export const isAdminDoctor = (role) => {
    return role==='AdminDoctor';    
}